import React from 'react';
import { Form, Row, Col, Button, Alert, Upload, Icon } from 'antd';
import { createStructuredSelector } from 'reselect';

import { connect } from 'react-redux';
import { compose } from 'redux';

import { selectIsLoading, selectTheme, selectErrors, selectHasErrors } from 'containers/App/selectors';
import { uploadLogo } from 'containers/App/actions';

import './styles.scss';

class FormRebrand extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      uploading: false,
      submitting: false,
      submitted: false,
      userTheme: props.userTheme,
      errors: {
        logo: false,
        theme: false,
      },
    };
  }

  resetErrors = input => {
    if (typeof input !== 'undefined') {
      this.setState({
        errors: { ...this.state.errors, [input]: false },
      });
    } else {
      this.setState(() => ({
        errors: {
          logo: false,
          theme: false,
        }
      }));
    }
  };

  // handleSubmit = e => {
  //   e.preventDefault();
  //   this.resetErrors();

  //   if (!this.state.submitting) {
  //     setTimeout(() => this.onAlertDismiss(), 1500);
  //   }
  // };

  handleThemeChange = ({target: {value}}) => {
    this.resetErrors();

    this.setState({ userTheme: value });
  };

  handleUploadChange = info => this.setState({ uploading: info.file.status === 'uploading' });

  beforeUpload = file => {
    const isImage = file.type.startsWith('image/');
    const isLt2M = file.size / 1024 / 1024 < 2;
    const logoErrors = [];

    if (!isImage) {
      logoErrors.push('Sono consentiti solo file di tipo immagine (png, jpg, gif, ...)');
    }

    if (!isLt2M) {
      logoErrors.push('Il file deve pesare meno di 2MB');
    }

    this.setState({ errors: {logo: logoErrors}})

    if (isImage && isLt2M) {
      this.props.uploadLogo(file);
    }

    return false;
  }

  onAlertDismiss = () => {
    this.setState({ submitted: false });
  };

  render() {
    let { userTheme, errors, submitted } = this.state;
    const { profile, hasErrors } = this.props;
    const rebrandHasErrors = hasErrors('rebrand')
    errors = { ...errors, ...this.props.rebrandErrors.rebrand || {} };

    return (
      <div id="RebrandForm" className="mt-4">
        {submitted || rebrandHasErrors ?
          <Alert
            showIcon
            closable
            afterClose={this.onAlertDismiss}
            type={rebrandHasErrors ? 'error' : 'success'}
            message={rebrandHasErrors ? 'Si sono verificati degli errori, controllare i dati inseriti' : 'Aggiornamento avvenuto con successo'}
            className="mb-3"
          />
          : null
        }
        <div className="form-content">
          <Row gutter={16}>
            {/* <Col span={11} className="b-r mr-4">
              <Form layout="vertical">
                <Form.Item
                  label="Scegli la palette di colori"
                  help={errors.theme && (errors.theme[0] || 'Questo campo è obbligatorio')}
                  validateStatus={errors.theme ? 'error' : null}
                >
                  {Object.keys(profile.themeColors).map(themeColorKey =>
                    <div className={`custom-control custom-radio ${themeColorKey}`} key={themeColorKey}>
                      <input
                        disabled
                        type="radio"
                        id={`themeColor${themeColorKey}`}
                        name="theme"
                        value={themeColorKey}
                        checked={themeColorKey === userTheme}
                        className="custom-control-input"
                        onChange={this.handleThemeChange}
                      />
                      <label className="custom-control-label" htmlFor={`themeColor${themeColorKey}`}>
                        {profile.themeColors[themeColorKey]}
                      </label>
                    </div>
                  )}
                </Form.Item>
              </Form>
            </Col> */}
            <Col span={24}>
              <Form layout="vertical">
              <Form.Item
                  label="Carica il tuo logo personalizzato"
                  help={errors.logo && errors.logo[0]}
                  validateStatus={errors.logo.length ? 'error' : null}
                >
                <Upload
                  name="logo"
                  accept="image/*"
                  listType="picture-card"
                  className="avatar-uploader"
                  showUploadList={false}
                  beforeUpload={this.beforeUpload}
                  onChange={this.handleUploadChange}
                >
                  {profile.logo ?
                    <img alt="Logo Profilo" src={profile.logo} className="img-fluid" />
                    :
                    <div>
                      <Icon type={this.state.uploading ? 'loading' : 'plus'} />
                      <div className="ant-upload-text">Upload</div>
                    </div>
                  }
                </Upload>
                </Form.Item>
              </Form>
            </Col>
          </Row>
          {/* <Row>
            <Col span={24}>
              <Button
                type="primary"
                className="float-right"
                onClick={this.handleSubmit}
              >
                <FormattedMessage {...messages.rebrandSubmit} />
              </Button>
            </Col>
          </Row> */}
        </div>
      </div>
    );
  }
}

export function mapDispatchToProps(dispatch) {
  return {
    uploadLogo: file => dispatch(uploadLogo(file)),
  };
}

const mapStateToProps = createStructuredSelector({
  isLoading: selectIsLoading(),
  userTheme: selectTheme(),
  rebrandErrors: selectErrors(),
  hasErrors: state => selectHasErrors(state, 'rebrand'),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(withConnect)(FormRebrand);
